export const ROUTER_LOGIN = "login";

export const ROUTER_ROOT = "root";

export const ROUTER_HOME = "home";

export const ROUTER_ABOUT = "about";

export const ROUTER_NUTRI_SEARCH = "nutri-search";

export const ROUTER_FOODCOMPOSITIONTABLE = "foodcompositiontable";

export const ROUTER_FOODCLASSIFY = "foodClassify";

export const ROUTER_NUTRITIONASSESSMENT ='nutritionAssessment';

export const ROUTER_ASSESSMENTBOTTOM = 'AssessmentBottom';

export const ROUTER_DETAIL = 'detail';

export const ROUTER_GLOBALSEARCH = 'globalSearch';

export const ROUTER_DATACOMPRESSION = 'dataCompression';

export const ROUTER_PRE_PACKAGEFOODBANK = 'Pre_packagedFoodBank';

export const ROUTER_PRE_FOODCLASSIFY = "Pre_foodClassify";

export const ROUTE_PRE_NUTRITIONASSESSMENT ='Pre_nutritionAssessment';

export const ROUTER_PRE_ASSESSMENTBOTTOM = 'Pre_AssessmentBottom';

export const ROUTER_PRE_DETAIL = 'Pre_detail';

export const ROUTER_PRE_GLOBALSEARCH = 'Pre_globalSearch';

export const ROUTER_PRE_DATACOMPRESSION = 'Pre_dataCompression';
